import React, { useEffect } from 'react';
import { Layout, theme } from 'antd';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import TitleBar from 'components/TitleBar';
import GoBackButton from 'components/GoBackButton';
import { RootState } from 'store/configureStore';
import { IWhoAmILayoutProps } from 'store/ducks/globalTypes';
import i18n from 'constants/translation/i18n';
import * as MainStyled from 'components/Layouts/Layout.styled';

const { Content, Sider } = Layout;
const { useToken } = theme;

const WhoAmILayout: React.FC<IWhoAmILayoutProps> = ({ children }) => {
  const { token } = useToken();
  const location = useLocation();
  const { lang } = useSelector((state: RootState) => ({
    lang: state.global.lang
  }));

  useEffect(() => {
    if (lang) {
      i18n.changeLanguage(lang);
    }
  }, [lang, i18n]);

  const getNavigationButtons = () => {
    const isOrganizationalContext =
      location.pathname === '/who_am_i/organizational_context';
    const isAllocation = location.pathname === '/who_am_i/allocation';

    return (
      <>
        <GoBackButton to='/working_area' text={i18n.t('WHO_AM_I_GO_BACK')} />
      </>
    );
  };

  return (
    <MainStyled.StyledLayout token={token}>
      <TitleBar
        title={
          location.pathname === '/who_am_i/organizational_context'
            ? i18n.t('FOCUS_AREA_MANAGEMENT')
            : i18n.t('WHO_AM_I')
        }
        goBackButtons={getNavigationButtons()}
      />
      <MainStyled.StyledLayout token={token}>
        <Layout>
          <Content>{children}</Content>
        </Layout>
      </MainStyled.StyledLayout>
    </MainStyled.StyledLayout>
  );
};

export default WhoAmILayout;
